<template>
  <div class="box16">
    <pageTitle title="免费试学课程" text />

    <commonFreeVideo pageName="软件测试-就业课" class="box" :videoList="videoList" />

    <!-- <div class="btn" @click="toLink('https://m.boxuegu.com/')"> -->
    <div class="btn" @click="zixun('查看更多')">
      查看更多
      <span>></span>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commonFreeVideo from "../common/common-free-video.vue";
export default {
  components: {
    pageTitle,
    commonFreeVideo,
  },
  data() {
    return {
      videoList: [
        {lessonName:"7小时小白轻松学测试",
          url: "https://www.boxuegu.com/freecourse/detail-4069.html",
          img: require("../../../assets/coursePage/softwareTest/box16/01.png"),
        },
        {lessonName:"Pytest框架快速入门",
          url: "https://www.boxuegu.com/freecourse/detail-2433.html",
          img: require("../../../assets/coursePage/softwareTest/box16/02.png"),
        },
        // {lessonName:"AI模型测试NLP智能文本分类",
        //   url: "https://www.boxuegu.com/freecourse/detail-1545.html",
        //   img: require("../../../assets/coursePage/softwareTest/box16/03.png"),
        // },
        {lessonName:"软件测试入门黑马头条项目实训",
          url: "https://www.boxuegu.com/freecourse/detail-1424.html",
          img: require("../../../assets/coursePage/softwareTest/box16/04.png"),
        },
        // {lessonName:"软件测试职业发展规划小米测试总监分享",
        //   url: "https://www.boxuegu.com/freecourse/detail-1544.html",
        //   img: require("../../../assets/coursePage/softwareTest/box16/05.png"),
        // },
        {lessonName:"1小时快速掌握Request接口测试",
          url: "https://www.boxuegu.com/freecourse/detail-2335.html",
          img: require("../../../assets/coursePage/softwareTest/box16/06.png"),
        },
      ],
    };
  },
  methods: {
    zixun(name) {
       this.mai("软件测试-就业课","查看更多",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box16 {
  padding: 80px 0px 38px;
  width: 100%;
  // background: url("../../../assets/coursePage/java/box13/bgc.png") no-repeat;
  // background-size: cover;
  overflow: hidden;
  .box {
    margin-top: 48px;
  }
  .btn {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: center;
    color: #165dff;
  }
}
</style>
